import photo from './resources/img/photo.webp';
import cv from './resources/files/CV_Leventsov.pdf';
import './resources/css/landing.css';
import { competencies, education, navigation, profile, projects, skillGroups } from './content';
import DeferredContactForm from './components/ContactForm/DeferredContactForm';
import Experience from './components/Experience/Experience';

function SectionTitle({ eyebrow, children }) {
    return (
        <div className="section-title">
            <span>{eyebrow}</span>
            <h2>{children}</h2>
        </div>
    );
}

function NavigationLinks() {
    return (
        <ul>
            {navigation.map(({ id, label }) => (
                <li key={id}><a href={`#${id}`}>{label}</a></li>
            ))}
        </ul>
    );
}

function LandingApp() {
    return (
        <div className="site-shell">
            <a className="skip-link" href="#main">К основному содержанию</a>
            <header className="site-header">
                <a className="brand" href="#top" aria-label="На начало страницы">AL<span>.</span></a>
                <nav className="desktop-navigation" aria-label="Основная навигация">
                    <NavigationLinks />
                </nav>
                <details className="mobile-navigation">
                    <summary>Разделы</summary>
                    <nav aria-label="Мобильная навигация"><NavigationLinks /></nav>
                </details>
            </header>

            <main id="main">
                <section className="hero" id="top" aria-labelledby="hero-title">
                    <div className="hero-copy">
                        <h1 id="hero-title">{profile.nameLines[0]}<br />{profile.nameLines[1]}</h1>
                        <p className="eyebrow hero-role">{profile.role}</p>
                        <p className="hero-lead">{profile.lead}</p>
                        <div className="hero-actions">
                            <a className="button button-primary" href="#contact">Связаться</a>
                            <a className="button button-secondary" href={cv} target="_blank" rel="noreferrer">Скачать CV</a>
                        </div>
                        <p className="hero-location">{`${profile.location} `}<span aria-hidden="true">·</span> Remote</p>
                        <dl className="hero-facts" aria-label="Кратко об опыте">
                            {profile.facts.map(({ value, label }) => (
                                <div key={value}><dt>{value}</dt><dd>{label}</dd></div>
                            ))}
                        </dl>
                    </div>
                    <div className="portrait-wrap">
                        <div className="portrait-accent" aria-hidden="true" />
                        <img src={photo} width="576" height="576" fetchpriority="high" decoding="async" alt={profile.name} />
                    </div>
                </section>

                <section className="section section-about" id="about" aria-labelledby="about-title">
                    <SectionTitle eyebrow="Профиль"><span id="about-title">Инженерия без лишней магии</span></SectionTitle>
                    <div className="about-grid">
                        <p className="about-lead">{profile.summaryLead}</p>
                        <div className="about-copy">
                            {profile.summary.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                        </div>
                    </div>
                    <div className="competency-grid">
                        {competencies.map((item) => (
                            <article className="competency-card" key={item.title}>
                                <span className="card-index">{item.number}</span>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="section" id="experience" aria-labelledby="experience-title">
                    <SectionTitle eyebrow="Карьера"><span id="experience-title">Опыт работы</span></SectionTitle>
                    <Experience />
                </section>

                <section className="section" id="skills" aria-labelledby="skills-title">
                    <SectionTitle eyebrow="Инструменты"><span id="skills-title">Технологический стек</span></SectionTitle>
                    <div className="skills-grid">
                        {skillGroups.map((group) => (
                            <article className="skill-group" key={group.title}>
                                <h3>{group.title}</h3>
                                <ul>{group.items.map((item) => <li key={item}>{item}</li>)}</ul>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="section" id="projects" aria-labelledby="projects-title">
                    <SectionTitle eyebrow="Практика"><span id="projects-title">Проекты и статьи</span></SectionTitle>
                    <div className="project-grid">
                        {projects.map((project) => (
                            <article className="project-card" key={project.url}>
                                <span>{project.kind}</span>
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>
                                <a href={project.url} target="_blank" rel="noreferrer">Читать на Habr <span aria-hidden="true">↗</span></a>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="section" id="education" aria-labelledby="education-title">
                    <SectionTitle eyebrow="База"><span id="education-title">Образование</span></SectionTitle>
                    <div className="education-list">
                        {education.map((item) => (
                            <article key={`${item.year}-${item.place}`}>
                                <time>{item.year}</time>
                                <div><h3>{item.title}</h3><p>{item.place}</p></div>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="section contact-section" id="contact" aria-labelledby="contact-title">
                    <div>
                        <SectionTitle eyebrow="На связи"><span id="contact-title">Обсудим задачу?</span></SectionTitle>
                        <p className="contact-lead">{profile.contactLead}</p>
                        <div className="contact-actions">
                            <a className="button button-primary" href={profile.telegramUrl} target="_blank" rel="noreferrer">Написать в Telegram</a>
                            <a className="button button-secondary" href={`mailto:${profile.email}`}>Написать по email</a>
                        </div>
                        <ul className="contact-links">
                            <li><span>Локация</span><strong>{profile.location}</strong></li>
                            <li><span>Формат</span><strong>Remote</strong></li>
                        </ul>
                    </div>
                    <DeferredContactForm />
                </section>
            </main>

            <footer>
                <span>{`© ${new Date().getFullYear()} ${profile.name}`}</span>
                <a href="#top">Наверх ↑</a>
            </footer>
        </div>
    );
}

export default LandingApp;
